module.exports = {
  email: 'noorulbaseer2021@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/NoorUlBaseer',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/noorulbaseersoomro2303',
    },
    /*{
      name: 'Twitter',
      url: '',
    },*/
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/noor-ul-baseer-940b7824a',
    },
    /*{
      name: 'Codepen',
      url: '',
    },*/
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Services',
      url: '/#services',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Blogs',
      url: '/#blogs',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    /*{
      name: 'Posts',
      url: '/pensieve',
    },*/
  ],

  colors: {
    green: '#4cc9f0',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.35) => {
    const isMobile =
      typeof window !== 'undefined' &&
      (window.innerWidth <= 1080 ||
        window.innerHeight <= 600 ||
        window.matchMedia('(hover: none)').matches);

    const isLandscapeMobile = typeof window !== 'undefined' && window.innerHeight <= 600;

    const finalViewFactor = isMobile ? 0.01 : viewFactor;
    const finalDistance = isMobile ? '10px' : '20px';
    const finalDuration = 500;
    const finalBottomOffset = isLandscapeMobile ? 20 : isMobile ? 40 : 100;

    return {
      origin: 'bottom',
      distance: finalDistance,
      duration: finalDuration,
      delay: delay,
      rotate: { x: 0, y: 0, z: 0 },
      opacity: 0,
      scale: 1,
      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      mobile: true,
      reset: false,
      useDelay: 'always',
      viewFactor: finalViewFactor,
      viewOffset: { top: 0, right: 0, bottom: finalBottomOffset, left: 0 },
    };
  },
};
